import { Select } from '@mantine/core';
import { tKeys, useTranslate } from 'locales/index';
import type { ReminderTemplate } from '../api/use-load-reminder-templates';

type ReminderTemplateSelectProps = {
  templates: Array<ReminderTemplate>;
  value: string;
  onChange: (id: string) => void;
  defaultTemplateId?: string;
};

export const ReminderTemplateSelect = ({
  templates,
  value,
  onChange,
  defaultTemplateId,
}: ReminderTemplateSelectProps) => {
  const t = useTranslate();

  const data = templates.map(template => ({
    value: template.id,
    label:
      template.id === defaultTemplateId
        ? `${template.name} (${t(tKeys.DEFAULT).toLowerCase()})`
        : template.name,
  }));

  return (
    <Select
      label={t(tKeys.COMMON.TEMPLATE)}
      data={data}
      value={value}
      onChange={selected => selected !== null && onChange(selected)}
      allowDeselect={false}
    />
  );
};
